module.exports = __webpack_public_path__ + "img/cashback.1f9c5d99.jpg";